import { PowerMeterModel } from 'src/Libs/power-meters'
import { fromDtoToModel } from 'src/Libs/power-meters/transformer'
import { PowerMeterOverviewDto } from 'src/Libs/power-meters/api'
import { useWebSocketApi } from '@e3dc-react/shell/Hooks'
import { SocketStateModel } from '@e3dc-react/shell/Hooks/use-websocket-api'
import { isUndefined } from 'lodash'

const SERVICE_ID = '[POWER METERS]'

/**
 * This hook provides the utils for accessing the Power Meter overviews through a websocket connection.
 * The returning information comes directly from the connected device.
 *
 * TODO: always return a valid object, as it happens in the battery settings
 */
const useLivePowerMeters = (storageId: string | undefined, powerMeterKey?: string): SocketStateModel<PowerMeterModel> | undefined => {
  const resourcePath = `storages/${storageId}/hardware/powermeters/overview/${powerMeterKey}/ws`

  const { socketState } = useWebSocketApi<PowerMeterModel, PowerMeterOverviewDto>({
    apiResourcePath: resourcePath,
    loggerKey: SERVICE_ID,
    transformer: fromDtoToModel,
    doNotInitialize: isUndefined(storageId) || isUndefined(powerMeterKey) || isNaN(parseInt(powerMeterKey)),
    endpoint: process.env.REACT_APP_API_ENDPOINT ?? '',
  })

  return socketState
}

export default useLivePowerMeters
